{
  "(disabled)": "[disabled]",
  "Actions": "Actions",
  "Add": "Add",
  "All": "All",
  "Approve": "Approve",
  "Archived": "Archived",
  "Back": "Back",
  "Both": "Both",
  "Cancel": "Cancel",
  "Close": "Close",
  "Clear": "Clear",
  "Complete": "Complete",
  "Confirm": "Confirm",
  "Confirmation": "Confirmation",
  "Content": "Content",
  "Continue": "Continue",
  "Create": "Create",
  "Date": "Date",
  "Delete": "Delete",
  "Description": "Description",
  "Download CSV": "Download CSV",
  "Download": "Download",
  "Edit": "Edit",
  "Error": "Error",
  "Exit": "Exit",
  "Email": "Email",
  "Status": "Status",
  "End date": "End date",
  "Finish": "Finish",
  "Format": "Format",
  "generic-error-reload-page": "An error occurred. Refresh the page and try again. Or contact support at <0>support@collegial.com</0>",
  "404-message": "Something went wrong. You can go <1><0>Back</0></1>, or contact <3><0>Support</0></3>",
  "404-archived-message": "This learning has been archived and is not accessible. You can go <1><0>Back</0></1>",
  "404-go-to-start-page": "Go to the start page",
  "404-page-not-found": "Page not found",
  "404-page-archived": "Learning archived",
  "Hidden": "Hidden",
  "ID": "ID",
  "Import": "Import",
  "Language": "Language",
  "Loading...": "Loading...",
  "Location": "Location",
  "Mandatory": "Mandatory",
  "Name": "Name",
  "New": "New",
  "Next": "Next",
  "No": "No",
  "No data": "No data",
  "Not started": "Not started",
  "Ongoing": "Ongoing",
  "Optional": "Optional",
  "Preview": "Preview",
  "Previous": "Previous",
  "Realm": "Realm",
  "Remove": "Remove",
  "Restore": "Restore",
  "Required": "Required",
  "Save": "Save",
  "Change": "Change",
  "Search": "Search",
  "Selected {{count}}/{{total}}": "Selected {{count}}/{{total}}",
  "Selected {{count}}/{{max}} (of {{total}})": "Selected {{count}}/{{max}} (out of {{total}})",
  "Setup": "Setup",
  "Show": "Show",
  "Space": "Space",
  "Start date": "Start date",
  "Superadmin": "Super admin",
  "Time": "Time",
  "Title": "Title",
  "Update": "Update",
  "User ID": "User ID",
  "Variant": "Variant",
  "View": "View",
  "Yes": "Yes",
  "Load more": "View more",
  "Load all": "View all",
  "Placeholder image": "Placeholder image",
  "Video": "Video content",
  "Length": "Length",
  "Type to search...": "Type to search...",
  "0": "zero",
  "1": "one",
  "1_neutrum": "one",
  "1_utrum": "one",
  "2": "two",
  "3": "three",
  "4": "four",
  "5": "five",
  "6": "six",
  "7": "seven",
  "8": "eight",
  "9": "nine",
  "These Terms of Use have been superseded. Follow the link to the current ones.": "These Terms of Use have been superseded. Follow the link to the current ones.",
  "New Terms of Use": "New Terms of Use",
  "These Privacy Notes have been superseded. Follow the link to the current ones.": "This Privacy Notice have been superseded. Follow the link to the current ones.",
  "New Privacy Notes": "New Privacy Notice",
  "Updated terms": "Updated terms",
  "Move Up": "Move Up",
  "Move Down": "Move Down",
  "remove-item": "Are you sure that you want to remove this {{item}}?",
  "remove-item_plural": "Are you sure that you want to remove these {{item}}?",
  "Group by": "Group by",
  "Choose...": "Choose...",
  "From": "From",
  "To": "To",
  "Show selected": "Show selected",
  "Clear selection": "Clear selection",
  "Manual": "Manual",
  "Select date": "Select date",
  "Category": "Category",
  "Type": "Learning Type",

  "Subject": "Subject",
  "Group": "Group",
  "Featured": "Featured",
  "Apply": "Apply",
  "learning Items": "Learning Items",
  "write-caption": "Write caption (optional)"
}
